import { render, staticRenderFns } from "./UserShipments.vue?vue&type=template&id=3721f179&scoped=true"
import script from "./UserShipments.vue?vue&type=script&lang=js"
export * from "./UserShipments.vue?vue&type=script&lang=js"
import style0 from "./UserShipments.vue?vue&type=style&index=0&id=3721f179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3721f179",
  null
  
)

export default component.exports